var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPorfidoOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 31.2 31.2",
    style: {
      enableBackground: "new 0 0 31.2 31.2"
    },
    xmlSpace: "preserve",
    width: "30px",
    height: "30px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F1961F;stroke:#13120C;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#1D1D1B;stroke-width:2;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.3,2c2.4-0.5,4.9-0.3,7.1,0.8c2,1,3.7,2.5,4.8,4.5c1.1,1.9,1.6,4.2,1.3,6.4c-0.3,1.9-1.1,3.7-2.2,5.3 c-0.9,1.4-2,2.7-3.1,4c-1.8,2.2-3.7,4.4-5.6,6.6c-2.1-2.3-4.3-4.6-6.3-7c-1.4-1.6-2.7-3.3-3.6-5.2C5,15.4,4.7,13.2,5,11 c0.3-2.2,1.4-4.4,2.9-6C9.4,3.5,11.3,2.4,13.3,2"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 26.5,
    y1: 10.9,
    x2: 4.5,
    y2: 10.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 12.4,
    y1: 2.2,
    x2: 12.7,
    y2: 2.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 12.7,
    y1: 2.2,
    x2: 12.7,
    y2: 25.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 23,
    y1: 21.1,
    x2: 8,
    y2: 21
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPorfidoOrange);
export default __webpack_public_path__ + "static/media/porfido_orange.acc4d873e3b8471f36df5340dffab0d1.svg";
export { ForwardRef as ReactComponent };